<template>
<div>
    <b-breadcrumb :items="items"/>
        <div class="container-fluid text-center" style="background-color: white;">
            <br>
            <h2 class="text-center p-3">เพิ่ม / แก้ไขข้อมูล คนขับ</h2>
            <br/>
            <!--data driver-->
            <div style="display: none">{{alertExpireDate}}</div>
            <div v-if="form.cancel_status" class="font-weight-bold text-danger text-left" style="font-size: 23px">
                ***คนขับคนนี้ถูกยกเลิกแล้ว
            </div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_insurance"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : ประกันภัยหมดอายุแล้ว
            </div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_act"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : พรบ.อายุแล้ว
            </div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_tax"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : ภาษีหมดอายุแล้ว
            </div>
            <div style="border: 1px solid black; padding: 20px">
                <div class="row">
                    <div class="col-sm-6">
                        <!--upload name-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ชื่อ
                            </label>
                            <div class="col-sm-8">
                                <input class="form-control"
                                       placeholder="ชื่อ"
                                       v-model="form.first_name"/>
                            </div>
                        </div>
                        <!--upload last name-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                นามสกุล
                            </label>
                            <div class="col-sm-8">
                                <input class="form-control"
                                       placeholder="นามสกุล"
                                       v-model="form.last_name"/>
                            </div>
                        </div>
                        <!--upload id_card-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เลขที่บัตรประชาชน
                            </label>
                            <div class="col-sm-8">
                                <masked-input v-model="form.id_card"
                                              mask="1-1111-11111-11-1"
                                              placeholder-char="-"
                                              placeholder="เลขที่บัตรประชาชน"
                                              class="form-control"
                                              type="tel" />
                            </div>
                        </div>
                        <!--upload phone-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เบอร์โทรศัพท์1
                            </label>
                            <div class="col-sm-8">
                                <masked-input v-model="form.phone"
                                              mask="111-111-1111"
                                              class="form-control"
                                              type="tel" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เบอร์โทรศัพท์2
                            </label>
                            <div class="col-sm-8">
                                <masked-input v-model="form.phone2"
                                              mask="111-111-1111"
                                              placeholder="เบอร์โทรศัพท์2"
                                              class="form-control"
                                              type="tel" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                เบอร์โทรศัพท์3
                            </label>
                            <div class="col-sm-8">
                                <masked-input v-model="form.phone3"
                                              mask="111-111-1111"
                                              placeholder="เบอร์โทรศัพท์3"
                                              class="form-control"
                                              type="tel" />
                            </div>
                        </div>
                        <!--increment-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                อัพโหลดสำเนาบัตรประชาชน
                            </label>
                            <div class="col-sm-8">
                                <b-form-file
                                    ref="card_file"
                                    @change="cardFileUpload"
                                    placeholder="Choose a file...">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row" v-if="form.id_card_file">
                            <div class="col-sm-4">

                            </div>
                            <label class="col-sm-8 col-form-label text-capitalize text-left">
                                <a style="cursor: pointer ; color: red" :href="form.id_card_file" target="_blank">
                                    สำเนาบัตรประชาชน <icon name="file-alt"></icon>
                                </a>
                            </label>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                อัพโหลดสัญญา
                            </label>
                            <div class="col-sm-8">
                                <b-form-file
                                    ref="contract_file"
                                    @change="contractFileUpload"
                                    placeholder="Choose a file...">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row" v-if="form.contract_file">
                            <div class="col-sm-4"></div>
                            <label class="col-sm-8 col-form-label text-capitalize text-left">
                                <a style="cursor: pointer ; color: red" :href="form.contract_file" target="_blank">
                                    ดูไฟล์สัญญา <icon name="file-alt"></icon>
                                </a>
                            </label>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                อัพโหลดสำเนาทะเบียนบ้าน
                            </label>
                            <div class="col-sm-8">
                                <b-form-file
                                    ref="home_file"
                                    @change="homeFileUpload"
                                    placeholder="Choose a file...">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row" v-if="form.register_home_file">
                            <div class="col-sm-4">
                            </div>
                            <label class="col-sm-8 col-form-label text-capitalize text-left">
                                <a style="cursor: pointer ; color: red" :href="form.register_home_file" target="_blank">
                                    ดูสำเนาทะเบียนบ้าน <icon name="file-alt"></icon>
                                </a>
                            </label>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <!--upload transport_type-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ประเภทรถ
                            </label>
                            <div class="col-sm-8">
                                <b-form-select :options="transportType"  v-model="form.transport_type_id">
                                </b-form-select>
                            </div>
                        </div>
                        <div class="form-group row" v-if="form.transport_type && form.transport_type.id == 1">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ยอดค่าผ่อนรถตั้งต้น
                            </label>
                            <div class="col-sm-8">
                                <input type="number" class="form-control" v-model="form.car_fee_total" placeholder="เช่น 1000000"/>
                            </div>
                        </div>
                        <!--upload license_plate-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ทะเบียนรถ
                            </label>
                            <div class="col-sm-8">
                                <input class="form-control"
                                       placeholder="ทะเบียนรถ"
                                       v-model="form.license_plate"/>
                            </div>
                        </div>
                        <!--upload key-->
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                รหัสกุญแจ
                            </label>
                            <div class="col-sm-8">
                                <input class="form-control"
                                       placeholder="รหัสกุญแจ"
                                       v-model="form.key"/>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                วันหมดอายุ พรบ.
                            </label>
                            <div class="col-sm-8">
                                <date-picker
                                    v-model="form.car_act_date"
                                    type="date"
                                    class="w-100"
                                    :format="changeFormat"
                                    :lang="lang"
                                    placeholder="วันที่">
                                </date-picker>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                วันหมดอายุ ภาษี
                            </label>
                            <div class="col-sm-8">
                                <date-picker
                                    v-model="form.tax_date"
                                    type="date"
                                    :format="changeFormat"
                                    :lang="lang"
                                    class="w-100"
                                    placeholder="วันที่">
                                </date-picker>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                วันหมดอายุ ประกันภัย
                            </label>
                            <div class="col-sm-8">
                                <date-picker
                                    v-model="form.insurance_date"
                                    type="date"
                                    :format="changeFormat"
                                    :lang="lang"
                                    class="w-100"
                                    placeholder="วันที่">
                                </date-picker>&nbsp;&nbsp;
                            </div>
                        </div>
                        <div class="form-group row" v-if="form.transport_type && form.transport_type.id == 3">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                ยอดค่าหลังคาตั้งต้น
                            </label>
                            <div class="col-sm-8">
                                <input type="number" class="form-control" v-model="form.car_roof_total" placeholder="เช่น 1000000"/>
                            </div>
                        </div>

                        <div class="form-group row" v-if="form.transport_type && form.transport_type.id == 3">
                            <label class="col-sm-4 col-form-label text-capitalize text-right">
                                รูปหลักฐาน
                            </label>
                            <div class="col-sm-8">
                                <b-form-file
                                    @change="roof_image"
                                    placeholder="Choose a file..."
                                    multiple="multiple">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="row">
                            <span class="col-2" v-for="(i,index) in form.image_roof_fee" style="position: relative;display: inline-block">
                                <img v-img :src="i.replace('/public', '')" width="50px" height="50px">
                                <span class="close" style="color: red" @click="deleteImageRoof(index)"></span>
                            </span>
                        </div>
                        <template v-if="form.cancel_status">
                            <div class="row form-group">
                                <div class="col-4 text-danger text-right">
                                    คืนเงินค่าประกัน
                                </div>
                                <div class="col-8">
                                    <input class="form-control" v-model="form.insurance_refund" disabled/>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-4 text-danger text-right">
                                    คืนเงินค่าผ่อนรถ
                                </div>
                                <div class="col-8">
                                    <input class="form-control" v-model="form.car_fee_refund" disabled/>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-4 text-danger text-right">
                                    คืนเงินฝากของคนรถ
                                </div>
                                <div class="col-8">
                                    <input class="form-control" v-model="form.deposit_refund" disabled/>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-4 text-danger text-right">
                                    ปิดยอดค่าหลังคา
                                </div>
                                <div class="col-8">
                                    <input class="form-control" v-model="form.car_roof_refund" disabled/>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div style="border: 1px solid black; padding: 20px">
                <h4>ข้อมูลเด็กรถ</h4>
                <div class="row" >
                    <div class="col-6">
                        <!---เด็กรถ 1--->
                        <div class="form-group row">
                            <div class="col-sm-8">
                                <a @click="chooseImage('image1')">
                                    <template v-if="form.photo_henchman_1">
                                        <img :src="form.photo_henchman_1" width="150px"
                                             style="color: white"/>
                                    </template>
                                    <template v-else>
                                        <img src="@/assets/upload_image.png" width="100px"
                                             style="color: white"/>
                                    </template>
                                </a>
                                <b-form-file id="image1"
                                             style="display: none"
                                             @change="uploadImage"
                                             size="lg">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-5 col-form-label text-capitalize text-right">
                                ชื่อ-นามสกุลเด็กรถคนที่ 1
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       placeholder="ชื่อ - นามสกุล"
                                       v-model="form.name_henchman_1"/>
                            </div>
                        </div>
                        <!---เด็กรถ 2--->
                        <div class="form-group row">
                            <div class="col-sm-8">
                                <a @click="chooseImage('image2')">
                                    <template v-if="form.photo_henchman_2">
                                        <img :src="form.photo_henchman_2" width="150px"
                                             style="color: white"/>
                                    </template>
                                    <template v-else>
                                        <img src="@/assets/upload_image.png" width="100px"
                                             style="color: white"/>
                                    </template>
                                </a>
                                <b-form-file id="image2"
                                             style="display: none"
                                             @change="uploadImage"
                                             size="lg">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-5 col-form-label text-capitalize text-right">
                                ชื่อ-นามสกุลเด็กรถคนที่ 2
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       placeholder="ชื่อ - นามสกุล"
                                       v-model="form.name_henchman_2"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <!---เด็กรถ 3 --->
                        <div class="form-group row">
                            <div class="col-sm-8">
                                <a @click="chooseImage('image3')">
                                    <template v-if="form.photo_henchman_3">
                                        <img :src="form.photo_henchman_3" width="150px"
                                             style="color: white"/>
                                    </template>
                                    <template v-else>
                                        <img src="@/assets/upload_image.png" width="100px"
                                             style="color: white"/>
                                    </template>
                                </a>
                                <b-form-file id="image3"
                                             style="display: none"
                                             @change="uploadImage"
                                             size="lg">
                                </b-form-file>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-5 col-form-label text-capitalize text-right">
                                ชื่อ-นามสกุลเด็กรถคนที่ 3
                            </label>
                            <div class="col-sm-6">
                                <input class="form-control"
                                       placeholder="ชื่อ - นามสกุล"
                                       v-model="form.name_henchman_3"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <!--button-->
            <div class="col text-center">
                <button @click="saveDriverData"
                        type="button"
                        class="btn btn-success"
                        v-if="!form.id || (form.id && (canViewSuperAdmin || user.username == 20609))">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก</button>&nbsp&nbsp
                <button @click="goToDriverList"
                        type="button"
                        class="btn btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
            <br/>
            <!-- table -->
            <div class="row">
                <span style="color: blue;text-align: left; padding-left: 30px">**รถเล็กไม่มีเงินฝาก,ค่าผ่อนรถ</span>
                <span style="color: red; text-align: right; margin-left: auto;padding-right: 30px">หากต้องการแก้ไขค่าเที่ยว ให้ทำการลบ TN นั้นๆไปก่อน จึงจะสามารถเลือก TN นั้นเพื่อบันทึกค่าเที่ยวได้</span>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">พิมพ์ค่าเที่ยว</th>
                        <th scope="col" v-if="permissionEditShipping || canViewSuperAdmin">แก้ไขค่าเที่ยว</th>
                        <th scope="col">เลขที่ใบแจ้งหนี้</th>
                        <th scope="col">วันที่รับเงิน</th>
                        <th scope="col">ชื่อลูกค้า</th>
                        <th scope="col">ค่าเที่ยว</th>
                        <th scope="col">ค่าพ่วง</th>
                        <th scope="col">โบนัส</th>
                        <th scope="col">ค่าประกัน</th>
                        <th scope="col">ค่าผ่อนรถ</th>
                        <th scope="col">ค่าผ่อนหลังคา</th>
                        <th scope="col">เงินฝาก</th>
                        <th scope="col">ชำระค่าเสียหาย</th>
                        <th scope="col">ภาษี ณ ที่จ่าย 1%</th>
                        <th scope="col" v-if="permissionEditShipping || canViewSuperAdmin">ลบรายการ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in driver_details_table">
                        <td>
                            <button type="button" class="btn btn-primary"
                                    @click="printDriverShipping(data.id)">
                                พิมพ์ค่าเที่ยว
                            </button>
                        </td>
                        <td v-if="permissionEditShipping || canViewSuperAdmin">
                            <button type="button" class="btn btn-outline-info"
                                    @click="showDriverDetails(data.id)">
                                <icon name="pencil-alt"></icon>
                                แก้ไขค่าเที่ยว
                            </button>
                        </td>
                        <td>
                            <template v-if="data.driver_details_invoices.length > 0" v-for="inv in data.driver_details_invoices">
                                <template v-if="inv.invoice">
                                    {{inv.invoice.invoice_id}}<br>
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>{{data.date | moment('DD/MM/YYYY')}}<br>{{data.created_user ? data.created_user.name : ''}}</td>
                        <td>
                            <template v-if="data.driver_details_invoices.length > 0" v-for="invoice in data.driver_details_invoices">
                                <template v-if="invoice.invoice && invoice.invoice.customer">
                                    {{invoice.invoice.customer_other ? invoice.invoice.customer_other.store_name : invoice.invoice.customer.store_name}}<br>
                                </template>
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.transport_fee_total">
                                {{data.transport_fee_total | currency }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.invoice_other_fee">
                                {{data.invoice_other_fee | currency }}
                            </template>
                            <template v-else>
                                -
                            </template>
                        </td>
                        <td>
                            <template v-if="data.bonus">
                                {{data.bonus | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.insurance_fee">
                                {{data.insurance_fee | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.car_fee">
                                {{data.car_fee | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.car_roof">
                                {{data.car_roof | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.deposit">
                                {{data.deposit | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.damages_fee">
                                {{data.damages_fee | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.tax">
                                {{data.tax | currency }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td v-if="permissionEditShipping || canViewSuperAdmin">
                            <button class="btn btn-danger"
                                    @click="showDeleteDriverDetailModal(data.id)"
                                    type="button">
                                <icon name="trash"></icon>
                                ลบรายการ
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="driver_details_table.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getPage">
                </vue-pagination>
            </div>
            <br>
            <b-modal hide-header hide-footer
                     ref="edit_data">
                <div style="text-align: center;">
                    <edit-driver-details-modal @submit="updateDriverDetails">
                    </edit-driver-details-modal>
                </div>
            </b-modal>
            <b-modal hide-header hide-footer
                     ref="delete_data">
                <div style="text-align: center;">
                    <delete-confirm-modal @submit="deleteDriverDetails">
                    </delete-confirm-modal>
                </div>
            </b-modal>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
            </b-modal>
        </div>
</div>
</template>

<script>
    import HeaderTitle from "../../HeaderTitle";
    import { mapState } from "vuex";
    import Multiselect from "vue-multiselect";
    import MaskedInput from 'vue-masked-input'
    import { domain } from "../../../util/Constants";
    import EditDriverDetailsModal from "./EditDriverDetailsModal";
    import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
    import VuePagination from "../../Pagination";
    import {canViewSuperAdmin} from "../../../util/Permissions";
    import moment from "moment";
    import DatePicker from 'vue2-datepicker';
    import Loading from "../../Utility/Loading";

    export default {
        components: {
            Loading,
            DeleteConfirmModal,
            EditDriverDetailsModal,
            HeaderTitle,Multiselect,
            VuePagination,
            DatePicker,
            MaskedInput},
        name: "driver-form",
        props: {
            id: { default: null }
        },
        data(){
            return {
                msg : '',
                status_loading : 1,
                items: [
                    {
                        text: "รายการคนขับ",
                        to: { name: "driver" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                seen : false,
                phone_array : "",
                card_file : "",
                home_file : "",
                contract_file:"",
                seen_upload_card : 1,
                seen_upload_home : 0,
                seen_upload_contract : 0,
                file : "",
                upload :{
                    card_file : "",
                    home_file : "",
                    contract_file : "",
                    roof_file:[]
                },
                expire_tax : false,
                expire_insurance : false,
                expire_act : false,
                delete_id : "",
                onSave : false,
                image_id : '',
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        created(){
            this.$store.dispatch('TransportType/setTransportTypes');
            this.$store.dispatch('InsuranceFee/getInsuranceTotal');
            this.getInvoiceFromDriver();
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                form : state=>{
                    return state.Driver.form
                },
                driver_details_table : state=>{
                    return state.DriverDetails.driver_details_table
                },
                transportType:state=>{
                    return [
                        {
                            value: null,
                            text: "เลือกประเภทรถ"
                        },

                        ...state.TransportType.transportTypeList.map(data => ({
                            value: data.id,
                            text: data.name,
                        }))
                    ]
                },
                dataPaginate:state=>{
                    return state.DriverDetails.dataPaginate
                },
                user:state=>{
                    return state.Auth.user;
                },
            }),
            alertExpireDate(){
                this.expire_tax = false;
                this.expire_insurance = false;
                this.expire_act = false;
                let currentDate = new Date();
                let insurance_date = this.form.insurance_date ? new Date(this.form.insurance_date) : null;
                let tax_date = this.form.tax_date ? new Date(this.form.tax_date) : null;
                let car_act_date = this.form.car_act_date ? new Date(this.form.car_act_date) : null;
                if(insurance_date && currentDate > insurance_date){
                    this.expire_insurance = true;
                }
                if(tax_date && currentDate > tax_date){
                    this.expire_tax = true;
                }
                if(car_act_date && currentDate > car_act_date){
                    this.expire_act = true;
                }
            },
            permissionEditShipping(){
                //คุณมด , เฮีย , แป้ง , มิ้ว(ขนส่ง) , มิ้ว(แก้บิล)
                if(this.user.id == 38 || this.user.id == 122 || this.user.id == 112){
                    return true;
                }else{
                    return false;
                }
            },
        },
        methods:{
            deleteImageRoof(image){
                this.form.image_roof_fee.splice(image, 1);
            },
            chooseImage(ref) {
                this.image_id = ref;
                document.getElementById(`${ref}`).click();
            },
            /*modal*/
            showEditDriverDetailModal(){
                this.$refs.edit_data.show();
            },
            hideEditDriverDetailModal(){
                this.$refs.edit_data.hide();
            },
            showDeleteDriverDetailModal(id){
                this.delete_id = id;
                this.$refs.delete_data.show();
            },
            hideDeleteDriverDetailModal(){
                this.$refs.delete_data.hide();
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            //get base64 image
            //บัตรประชาชน
            cardFileImage: function(event) {
                this.card_file = [];
                let input = event.target;
                for (let i = 0; i < input.files.length; i++) {
                    if (input.files && input.files[i]) {
                        let ImageName = input.files && input.files[i].name;
                        let reader = new FileReader();
                        reader.onload = e => {
                            this.card_file.push({
                                file : e.target.result,
                                name : ImageName
                            });
                        };
                        reader.readAsDataURL(input.files[i]);
                    }
                }
            },
            contractFileUpload:function(event){
                let input = event.target;
                let file = input.files[0];
                let formData = new FormData();
                formData.append('file',file);
                this.$store.dispatch("Common/getPathFile",formData).then(path=>{
                    this.form.contract_file = path;
                })
            },
            homeFileUpload:function(event){
                let input = event.target;
                let file = input.files[0];
                let formData = new FormData();
                formData.append('file',file);
                this.$store.dispatch("Common/getPathFile",formData).then(path=>{
                    this.form.register_home_file = path;
                })
            },
            cardFileUpload:function () {
                let input = event.target;
                let file = input.files[0];
                let formData = new FormData();
                formData.append('file',file);
                this.$store.dispatch("Common/getPathFile",formData).then(path=>{
                    this.form.id_card_file = path;
                })
            },
            roof_image:function(){
                let input = event.target;
                let formData = new FormData();
                for( let i = 0; i < input.files.length; i++ ){
                    let file = input.files[i];
                    formData.append('files[' + i + ']', file);
                }
                this.form.image_roof_fee = this.form.image_roof_fee ? this.form.image_roof_fee:[];
                this.$store.dispatch("Common/getPathFiles",formData).then(path=>{
                    path.forEach(p => {
                        this.form.image_roof_fee.push(p);
                    })
                })
            },
            saveDriverData(){
                if(this.form.id && this.form.sum_car_fee > this.form.car_fee_total){
                    alert('ยอดตั้งต้นค่าผ่อนรถไม่ถูกต้อง');
                }else{
                    this.form.car_act_date = this.form.car_act_date ? moment(this.form.car_act_date).format("YYYY-MM-DD") : '';
                    this.form.tax_date = this.form.tax_date ? moment(this.form.tax_date).format("YYYY-MM-DD") : '';
                    this.form.insurance_date = this.form.insurance_date ? moment(this.form.insurance_date).format("YYYY-MM-DD") : '';
                    this.$store.dispatch('Driver/save',{
                        id : this.form.id,
                        data : this.form,
                    }).then(()=>{
                        this.goToDriverList();
                    })
                }
            },
            goToDriverList(){
                this.$router.push({name : "driver"});
            },
            printDriverShipping(id){
                window.open(domain+'/driver-shipping-pdf/'+id ,'_blank')
            },
            showDriverDetails(id){
                this.showLoadingModal();
                this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่"
                this.status_loading = 1;
                this.$store.dispatch("DriverDetails/showDriverDetails",{
                    id,
                }).then(()=>{
                    this.getInvoiceFromDriver();
                    this.showEditDriverDetailModal();
                    this.hideLoadingModal();
                })
            },
            getInvoiceFromDriver(){
                if(this.form.id){
                    this.$store.dispatch("DriverDetails/getInvoiceFromDriver",{
                        driver_id : this.form.id
                    });
                }else{
                    this.$store.dispatch("DriverDetails/clearForm");
                }
            },
            updateDriverDetails(data){
                if(data){
                    this.onSave = true;
                    this.showLoadingModal();
                    this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่"
                    this.status_loading = 1;
                    this.$store.dispatch("DriverDetails/updateDriverDetails",data)
                        .then(()=>{
                            //showDriverDetailsId
                            this.onSave = false;
                            this.getPage();
                        }).catch(err=>{
                        this.msg = "บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง"
                        this.status_loading = 3;
                        this.onSave = false;
                    })
                }
                this.hideEditDriverDetailModal();
            },
            deleteDriverDetails(submit){
                if(submit){
                    this.onSave = true;
                    this.$store.dispatch("DriverDetails/deleteDriverDetails",this.delete_id)
                        .then(()=>{
                            alert('ลบรายการสำเร็จ');
                            this.onSave = false;
                            this.getPage();
                        }).catch(err=>{
                        alert('ลบรายการไม่สำเร็จ');
                        this.onSave = false;
                    })
                }
                this.hideDeleteDriverDetailModal();
            },
            getPage(){
                this.$store.dispatch("DriverDetails/showDriverDetailsId",{
                    driver_id : this.form.id,
                    page : this.dataPaginate.current_page,
                }).then(()=>{
                    this.msg = "บันทึกสำเร็จ"
                    this.status_loading = 2;
                })
            },

            //upload image เด็กรถ
            uploadImage:function(event){
                let input = event.target;
                let file = input.files[0];
                if(file){
                    let formData = new FormData();
                    formData.append('file',file);
                    this.$store.dispatch("Common/getPathFile",formData).then(path_file=>{
                        if(this.image_id == 'image1'){
                            this.form.photo_henchman_1 = path_file;
                        }
                        if(this.image_id == 'image2'){
                            this.form.photo_henchman_2 = path_file;
                        }
                        if(this.image_id == 'image3'){
                            this.form.photo_henchman_3 = path_file;
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .close:before {
        content: '✕';
    }
    .close {
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
    }
</style>
